<template>
  <v-container class="fill-height background-color: primary" fluid>
    <v-row align="center" justify="center" no-gutters>
      <v-col cols="12" sm="12" md="3" xl="3">
        <LoginForm redirect="/desk"></LoginForm>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginForm from "@/components/auth/Login";
export default {
  name: "LoginView",
  components: {
    LoginForm
  }
};
</script>

<style>
</style>